import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MuiDialog, { DialogProps } from '@mui/material/Dialog';

interface IProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  maxWidth?: DialogProps['maxWidth'];
  title: string;
  okText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export default function DialogConfirm(props: IProps) {
  const { t } = useTranslation();
  const {
    open,
    onClose,
    children,
    maxWidth,
    title,
    okText,
    cancelText,
    onConfirm,
    onCancel,
  } = props;

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth || 'xs'}
    >
      <DialogTitle>{title}</DialogTitle>
      {children && <DialogContent>{children}</DialogContent>}
      <DialogActions>
        <Button
          onClick={() => {
            if (onCancel) {
              onCancel();
            }
            onClose();
          }}
          color="primary"
        >
          {cancelText || t('no')}
        </Button>
        <Button
          onClick={(e) => {
            if (onConfirm) {
              onConfirm();
            }
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          {okText || t('yes')}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
}
